/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.6.0",
  "gitBuildTime": "2026-03-02T17:02:23.877Z",
  "gitBuildVersion": "2.6.0",
  "gitCommitId": "3bbc3ba",
  "gitCommitIdFull": "3bbc3ba811a17a258cb790dde0e63d5ef2add270",
  "gitCommitTime": "2026-03-02T16:38:45.000Z",
  "version": "2.6.0-2026-03-02T16:38:45.000Z-(3bbc3ba)"
};
